import React from 'react';
import { Container } from 'react-bootstrap';
import b from './somwhere.gif'
const Blogs = () => {
    return (
        <Container fluid>
            <div className="Title mb-5">
                <h3>Blogs
                    <span> Coming soon</span>
                </h3>

            </div>
            <img src={b} alt="" height='350' className='gif' />
        </Container>
    );
};

export default Blogs;